module.exports = __webpack_public_path__ + "static/media/image02.bf2441e1.png";